import React from 'react';

import { CourseToolbar, CourseList } from 'views/Course/components';
import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CourseToolbar />
      <div className={classes.content}>
        <CourseList />
      </div>
    </div>
  );
};
